import React, { useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Topbar from "../components/Topbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import gsap from "gsap";

const Sitemap = () => {
  const contentRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      contentRef.current.querySelectorAll(".sitemap-section"),
      { opacity: 0, y: 30 },
      {
        opacity: 1,
        y: 0,
        duration: 0.8,
        stagger: 0.1,
        ease: "power3.out",
      }
    );
  }, []);

  const sitemapData = [
    {
      title: "Main Pages",
      links: [
        { name: "Home", url: "/" },
        { name: "About Us", url: "/about" },
        { name: "Contact", url: "/contact" },
        { name: "Blog", url: "/blog" },
        { name: "FAQ", url: "/faqs" }
      ]
    },
    {
      title: "Product Categories",
      links: [
        { name: "Women's Fragrances", url: "/fragrance?category=women" },
        { name: "Men's Fragrances", url: "/fragrance?category=men" },
        { name: "Unisex Fragrances", url: "/fragrance?category=unisex" },
        { name: "Gift Sets", url: "/fragrance?category=gifts" },
        { name: "Best Sellers", url: "/bestsales" },
        { name: "New Year Sale 2025", url: "/fragrance?category=new_year_sale" }
      ]
    },
    {
      title: "Customer Service",
      links: [
        { name: "Shipping Information", url: "/shipping" },
        { name: "Return Policy", url: "/return_policy" },
        { name: "Privacy Policy", url: "/privacy_policy" },
        { name: "Track Your Order", url: "/track_order" },
        { name: "Wholesale Information", url: "/wholesale_information" },
        { name: "Damage/Defective Policy", url: "/damage" },
        { name: "Rewards Program", url: "/rewards" }
      ]
    },
    {
      title: "Account & Shopping",
      links: [
        { name: "My Account", url: "/user" },
        { name: "Shopping Cart", url: "/cart" },
        { name: "Wishlist", url: "/user/favorite" },
        { name: "Order History", url: "/user/order_history" },
        { name: "Address Book", url: "/user/address" },
        { name: "Payment Methods", url: "/user/card" }
      ]
    },
    {
      title: "Legal & Policies",
      links: [
        { name: "Terms of Service", url: "/terms" },
        { name: "Privacy Policy", url: "/privacy_policy" },
        { name: "Return Policy", url: "/return_policy" },
        { name: "Shipping Policy", url: "/shipping" }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Topbar />
      <div className="bg-black">
        <Navbar />
      </div>
      
      {/* Hero Section */}
      <div className="relative py-20 px-4 text-center text-white bg-gray-900">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-[#A88006]">
            Sitemap
          </h1>
          <p className="text-xl text-gray-300 leading-relaxed">
            Navigate through all pages and sections of Gift of God Fragrances website.
          </p>
        </div>
      </div>

      {/* Sitemap Content */}
      <div ref={contentRef} className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {sitemapData.map((section, index) => (
            <div key={index} className="sitemap-section bg-white p-6 rounded-xl border border-[#A88006]/20 shadow-lg">
              <h2 className="text-xl font-bold text-[#A88006] mb-4">{section.title}</h2>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <Link 
                      to={link.url}
                      className="text-gray-700 hover:text-[#A88006] transition-colors text-sm block py-1"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-16 text-center bg-gradient-to-r from-[#A88006]/10 to-[#9F7800]/10 p-8 rounded-xl border border-[#A88006]/20">
          <h3 className="text-2xl font-bold text-black mb-4">Need Help Finding Something?</h3>
          <p className="text-gray-700 mb-6">
            Use our search function or contact our customer service team for assistance.
          </p>
          <Link 
            to="/contact"
            className="bg-gradient-to-r from-[#A88006] to-[#9F7800] text-white font-semibold px-6 py-3 rounded-lg hover:opacity-90 transition-all inline-block"
          >
            Contact Support
          </Link>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Sitemap;